import {
  ButtonLoadingEllipsis,
  OutlineButton,
  SolidButton,
} from "@/components/StoreComponents/StoreButton";
import { formatMoney } from "@/utils/StringUtils";
import { useCheckoutUI } from "../../CheckoutUIProvider";
import { useLoadingCheckoutIntent } from "../../hooks/useLoadingCheckoutIntent";

export const SubmitCheckoutButton = ({
  showTotal = false,
}: {
  showTotal?: boolean;
}) => {
  const [state, send] = useCheckoutUI();
  const { checkoutIntent } = state.context;

  const { loading } = useLoadingCheckoutIntent();

  const showEnabledSubmitButton =
    state.value === "ready_to_checkout" || state.value === "checking_out";

  if (loading) {
    return (
      <OutlineButton
        disableMaxWidth
        disabled
        style={{ width: "100%", maxWidth: "unset" }}
      >
        <ButtonLoadingEllipsis baseFontSize={16} blue />
      </OutlineButton>
    );
  }

  return showEnabledSubmitButton ? (
    <SolidButton
      disableMaxWidth
      disabled={state.value !== "ready_to_checkout"}
      onClick={() => send({ type: "SUBMIT_CHECKOUT" })}
      style={{
        width: "100%",
        maxWidth: "unset",
      }}
    >
      {state.value === "checking_out" ? (
        <ButtonLoadingEllipsis baseFontSize={16} />
      ) : (
        <>
          Submit my order
          {showTotal && (
            <>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              {formatMoney(checkoutIntent?.estimatedOrderSummary?.total!)}
            </>
          )}
        </>
      )}
    </SolidButton>
  ) : (
    <OutlineButton disableMaxWidth disabled style={{ width: "100%" }}>
      Submit my order
    </OutlineButton>
  );
};
